// extracted by mini-css-extract-plugin
export var addWidgetButton = "_p-6";
export var backButton = "_p-1";
export var pageContainer = "_p-2";
export var settingsContent = "_p-0";
export var widgetContainer = "_p-5";
export var widgetSubsectionItem = "_p-3";
export var widgetSubsectionItemContent = "_p-4";